import { takeLatest } from 'redux-saga/effects';
import {
  getHolidayListSuccess, getHolidayListFail,
  getHolidayDetailsSuccess, getHolidayDetailsFail
} from './holidayState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/system/holidays');
const redirectData = {route:'/console/holidays', mode: 'list', recordId:0 };
const modelName = 'Holiday';
const modelId = 'hol_id';

function* getHolidayList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getHolidayListSuccess, 
		getHolidayListFail, null, null, LOADING_MSG);
}

function* getHolidayDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getHolidayDetailsSuccess, 
		getHolidayDetailsFail, null, null, LOADING_MSG);		
}

function* doHolidayCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getHolidayDetailsSuccess, 
		getHolidayDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: 'reload'},
		SAVING_MSG);
}

function* doHolidayUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getHolidayDetailsSuccess, 
		getHolidayDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG);	
}

function* doHolidayDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getHolidayDetailsSuccess, 
		getHolidayDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* holidaySaga() {
  yield takeLatest('holiday/getHolidayList', getHolidayList);
  yield takeLatest('holiday/getHolidayDetails', getHolidayDetails);
  yield takeLatest('holiday/doHolidayCreate', doHolidayCreate);
  yield takeLatest('holiday/doHolidayUpdate', doHolidayUpdate);
  yield takeLatest('holiday/doHolidayDelete', doHolidayDelete);  
}

export default holidaySaga;
